import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const nav = [
  { to: '/student', label: 'Home', icon: '🏠', end: true },
  // The Daily Test is the cumulative subject paper (see routers/daily_paper.py).
  // The older auto-built /student/daily-test mode is dormant — it has never run and it
  // writes AI-generated questions, which the owner has ruled out. Its route still exists;
  // only the nav link is removed. Restore the line below to bring it back.
  // { to: '/student/daily-test', label: 'Daily Test (auto)', icon: '📅' },
  { to: '/student/daily-paper', label: 'Daily Test', icon: '📅' },
  { to: '/student/chapter-tests', label: 'Chapter Tests', icon: '📚' },
  { to: '/student/daily-target', label: 'Module Tests', icon: '🎯' },
  { to: '/student/test/new', label: 'Take Test', icon: '📝' },
  { to: '/student/history', label: 'My Tests', icon: '📋' },
  { to: '/student/videos', label: 'Videos', icon: '🎬' },
  { to: '/student/cards', label: 'Revision Cards', icon: '🃏' },
];

export default function StudentLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <header style={{
        background: 'var(--sidebar-bg)', color: 'white', padding: '0 24px',
        display: 'flex', alignItems: 'center', height: 60,
        position: 'sticky', top: 0, zIndex: 100,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginRight: 32, flexShrink: 0 }}>
          <span style={{ fontSize: 20 }}>🎯</span>
          <span style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 16 }}>Dream NEET</span>
        </div>
        <nav style={{ display: 'flex', gap: 2, flex: 1, overflowX: 'auto' }}>
          {nav.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 6, padding: '6px 12px',
              borderRadius: 8, textDecoration: 'none', fontSize: 13, whiteSpace: 'nowrap',
              color: isActive ? 'white' : '#A5B4FC',
              background: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
              fontWeight: isActive ? 600 : 400,
            })}>
              <span>{n.icon}</span>{n.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 12, flexShrink: 0 }}>
          <span style={{ fontSize: 13, color: '#A5B4FC' }}>{user?.full_name}</span>
          <button onClick={handleLogout} className="btn btn-ghost btn-sm"
            style={{ color: '#A5B4FC', borderColor: 'rgba(255,255,255,0.2)' }}>
            Sign Out
          </button>
        </div>
      </header>
      <main style={{ maxWidth: 1100, margin: '0 auto', padding: '28px 20px' }}>
        <Outlet />
      </main>
    </div>
  );
}
